import Vue from 'vue';

const mutations = {
    add(state, object) {
        state.itens.push(object);
    },
    setList(state, list) {
        state.itens = list;
    },
    setObject(state, object) {
        state.item = {};
        state.item = object;
    },
    setPrintable(state, object) {
        state.printable = object;
    },
    payInstallment(state, object) {
        var installmentIndex = state.item.installments.findIndex(installment => installment.id == object.id);
        Vue.set(state.item.installments, installmentIndex, object);
    },
    setObjectInstallments(state, object) {
        state.item.installments = object;
    },
    delObject(state, object) {
        state.itens.splice(state.itens.indexOf(object), 1);
    }
};

export default mutations;